module.exports = __webpack_public_path__ + "static/media/drapcode-logo-white.1032567b.svg";